// Feature Collection V2 Slider Js
$(document).ready(function () {
  if (window.innerWidth > 767) {
    $(".featured_collection-v2 .featured_col-slider").slick({
      infinite: false,
      autoplay: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      swipe: true,
      lazyLoad: "ondemand",
      prevArrow:
        '<button class="slide-arrow prev-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.2071 14.219C38.7577 8.04951 33.9386 3.23355 27.7681 1.78834C23.3118 0.744621 18.6745 0.746176 14.219 1.79288C8.04948 3.24223 3.23353 8.06142 1.78831 14.2319C0.744599 18.6881 0.746153 23.3254 1.79285 27.781C3.2422 33.9505 8.06139 38.7665 14.2319 40.2117C18.6881 41.2554 23.3254 41.2538 27.781 40.2071C33.9505 38.7578 38.7664 33.9386 40.2116 27.7681C41.2554 23.3119 41.2538 18.6746 40.2071 14.219Z" stroke="black" stroke-width="2"/><path d="M28.7749 20.9966L13.2245 21.0018M13.2245 21.0018L18.7764 15.4462M13.2245 21.0018L18.7801 26.5536" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button class="slide-arrow next-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.79266 14.219C3.24201 8.04951 8.0612 3.23355 14.2317 1.78834C18.6879 0.744621 23.3252 0.746176 27.7808 1.79288C33.9503 3.24223 38.7662 8.06142 40.2114 14.2319C41.2552 18.6881 41.2536 23.3254 40.2069 27.781C38.7576 33.9505 33.9384 38.7665 27.7679 40.2117C23.3116 41.2554 18.6743 41.2538 14.2188 40.2071C8.0493 38.7578 3.23334 33.9386 1.78812 27.7681C0.744402 23.3119 0.745957 18.6746 1.79266 14.219Z" stroke="#242424" stroke-width="2"/><path d="M13.2252 20.9966L28.7755 21.0018M28.7755 21.0018L23.2237 15.4462M28.7755 21.0018L23.22 26.5536" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.2,
          },
        },
      ],
    });
  }
});

// Custom Review Slider Js

$(document).ready(function () {
  $(".c_review_slider").slick({
    infinite: true,
    autoplay: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    lazyLoad: "ondemand",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg width="66" height="64" viewBox="0 0 66 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 32C66 49.6731 51.2254 64 33 64C14.7746 64 0 49.6731 0 32C0 14.3269 14.7746 0 33 0C51.2254 0 66 14.3269 66 32Z" fill="white"/><g filter="url(#filter0_d_24_38)"><path d="M28 24L37.3114 32.2948C37.3551 32.3337 37.3548 32.4021 37.3108 32.4407L28.1961 40.433" stroke="#242424" stroke-width="2.92" stroke-linecap="round"/></g><defs><filter id="filter0_d_24_38" x="22.54" y="22.54" width="20.2639" height="27.353" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24_38"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24_38" result="shape"/></filter></defs></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg width="66" height="64" viewBox="0 0 66 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 32C66 49.6731 51.2254 64 33 64C14.7746 64 0 49.6731 0 32C0 14.3269 14.7746 0 33 0C51.2254 0 66 14.3269 66 32Z" fill="white"/><g filter="url(#filter0_d_24_38)"><path d="M28 24L37.3114 32.2948C37.3551 32.3337 37.3548 32.4021 37.3108 32.4407L28.1961 40.433" stroke="#242424" stroke-width="2.92" stroke-linecap="round"/></g><defs><filter id="filter0_d_24_38" x="22.54" y="22.54" width="20.2639" height="27.353" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24_38"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24_38" result="shape"/></filter></defs></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

// Before After (Center) Js

$(document).ready(function () {
  $(".before_after-slider").slick({
    infinite: true,
    autoplay: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: true,
    centerMode: true,
    centerPadding: "0",
    lazyLoad: "ondemand",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.2071 14.219C38.7577 8.04951 33.9386 3.23355 27.7681 1.78834C23.3118 0.744621 18.6745 0.746176 14.219 1.79288C8.04948 3.24223 3.23353 8.06142 1.78831 14.2319C0.744599 18.6881 0.746153 23.3254 1.79285 27.781C3.2422 33.9505 8.06139 38.7665 14.2319 40.2117C18.6881 41.2554 23.3254 41.2538 27.781 40.2071C33.9505 38.7578 38.7664 33.9386 40.2116 27.7681C41.2554 23.3119 41.2538 18.6746 40.2071 14.219Z" stroke="#242424" stroke-width="2"/><path d="M28.7749 20.9967L13.2245 21.0019M13.2245 21.0019L18.7764 15.4463M13.2245 21.0019L18.7801 26.5537" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.79266 14.219C3.24201 8.04951 8.0612 3.23355 14.2317 1.78834C18.6879 0.744621 23.3252 0.746176 27.7808 1.79288C33.9503 3.24223 38.7662 8.06142 40.2114 14.2319C41.2552 18.6881 41.2536 23.3254 40.2069 27.781C38.7576 33.9505 33.9384 38.7665 27.7679 40.2117C23.3116 41.2554 18.6743 41.2538 14.2188 40.2071C8.0493 38.7578 3.23334 33.9386 1.78812 27.7681C0.744402 23.3119 0.745957 18.6746 1.79266 14.219Z" stroke="#242424" stroke-width="2"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 749,
        settings: {
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".before_after-slide").click(function () {
    let index = $(this).data("slick-index");
    $(".before_after-slider").slick("slickGoTo", index);
  });
});


// Before After Slider v2 Js
$(document).ready(function () {
  $(".before-after-slider-v2").slick({
    infinite: true,
    autoplay: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    lazyLoad: "ondemand",
    swipe: true,
    touchThreshold: 20,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40.2071 14.219C38.7577 8.04951 33.9386 3.23355 27.7681 1.78834C23.3118 0.744621 18.6745 0.746176 14.219 1.79288C8.04948 3.24223 3.23353 8.06142 1.78831 14.2319C0.744599 18.6881 0.746153 23.3254 1.79285 27.781C3.2422 33.9505 8.06139 38.7665 14.2319 40.2117C18.6881 41.2554 23.3254 41.2538 27.781 40.2071C33.9505 38.7578 38.7664 33.9386 40.2116 27.7681C41.2554 23.3119 41.2538 18.6746 40.2071 14.219Z" stroke="#242424" stroke-width="2"/><path d="M28.7749 20.9967L13.2245 21.0019M13.2245 21.0019L18.7764 15.4463M13.2245 21.0019L18.7801 26.5537" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.79266 14.219C3.24201 8.04951 8.0612 3.23355 14.2317 1.78834C18.6879 0.744621 23.3252 0.746176 27.7808 1.79288C33.9503 3.24223 38.7662 8.06142 40.2114 14.2319C41.2552 18.6881 41.2536 23.3254 40.2069 27.781C38.7576 33.9505 33.9384 38.7665 27.7679 40.2117C23.3116 41.2554 18.6743 41.2538 14.2188 40.2071C8.0493 38.7578 3.23334 33.9386 1.78812 27.7681C0.744402 23.3119 0.745957 18.6746 1.79266 14.219Z" stroke="#242424" stroke-width="2"/><path d="M13.2252 20.9967L28.7755 21.0019M28.7755 21.0019L23.2237 15.4463M28.7755 21.0019L23.22 26.5537" stroke="#242424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".before-after-slide-v2").click(function () {
    let index = $(this).data("slick-index");
    $(".before-after-slider-v2").slick("slickGoTo", index);
  });
});

// Product TAbs Js

const tabs = document.querySelectorAll(".tabs-block [data-tab-target]");
const tabContents = document.querySelectorAll(".tabs-block [data-tab-content]");
const mediaWrapper = document.getElementById("sticky-media");

tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    const target = document.querySelector(tab.dataset.tabTarget);
    tabContents.forEach((tabContent) => {
      tabContent.classList.remove("active");
    });
    tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
    tab.classList.add("active");
    target.classList.add("active");

    handleScroll();
  });
});

// Tabs indicator
document.addEventListener("DOMContentLoaded", () => {
  const containerEle = document.querySelector(".custom-tab");
  const indicatorEle = document.getElementById("selectedIndicator");
  const buttons = containerEle.querySelectorAll(".tabs__title");

  const activateTab = (index) => {
    const button = buttons[index];
    const buttonRect = button.getBoundingClientRect();

    const containerRect = containerEle.getBoundingClientRect();
    const containerPaddingLeft =
      window.getComputedStyle(containerEle).paddingLeft;
    const left =
      buttonRect.left - containerRect.left - parseInt(containerPaddingLeft, 10);

    indicatorEle.style.width = `${buttonRect.width}px`;
    indicatorEle.style.transform = `translateX(${left}px)`;
  };

  activateTab(0);

  [...buttons].forEach((button, index) => {
    button.addEventListener("click", () => {
      activateTab(index);

      handleScroll();
    });
  });
});

// JavaScript for quantity controls
$(document).ready(function () {
  // Set default values for quantity inputs
  $("#people_quantity").val($("#people_quantity").val() || 1);
  $("#pet_quantity").val($("#pet_quantity").val() || 0);

  // Handle click events for quantity control buttons
  $(document).on("click", ".quantity-control-btn", function () {
    let input = $(this).siblings('input[type="number"]');
    let value = parseInt(input.val());
    if ($(this).hasClass("plus") && value < input.attr("max")) {
      input.val(value + 1);
    } else if ($(this).hasClass("minus") && value > input.attr("min")) {
      input.val(value - 1);
    }
    setTimeout(function () {
      $(".product-form__submit").removeClass("disabledAtc");

      $(".active_person select").each(function () {
        console.log($(this).val());
        if ($(this).val() == null) {
          $(".product-form__submit").addClass("disabledAtc");
          return false;
        }
      });
    }, 1000);
  });
});


$('img').on('mousedown', function(e){
      // This event will trigger when the user tries to change the image by dragging.
      console.log('Image change attempt detected!');
      // You can add your custom logic here.
  });

// Upload Image Js
function handleFileUpload(input) {
  const uploadLabel = input.parentNode.querySelector(".upload_label");
  uploadLabel.textContent = 'Upload: .jpg, .jpeg, ...';
  const checkIcon = input.parentNode.querySelector(".check_icon");
  const tooltip = input.parentNode.querySelector(".info_tooltip");
  const maxWords = window.innerWidth > 1080 ? 35 : 25;

  if (input.files.length > 0) {
    const fileName = input.files[0].name;
    const shortenedFileName =
      fileName.length > maxWords
        ? fileName.slice(0, maxWords) + "..."
        : fileName;
    uploadLabel.textContent = shortenedFileName;
    checkIcon.style.display = "inline-block";
    // tooltip.textContent = fileName;
    // Remove the disabled attribute from the finalize_button
    const finalizeButton = document.querySelector(".finalize_button");
    // debugger;
    if (finalizeButton && finalizeButton.hasAttribute("disabled")) {
      finalizeButton.removeAttribute("disabled");
    }
    const finalize_message = document.querySelector(".finalize_message");
    finalize_message.style.display = "none";
    const clickable = document.querySelector("#clickable");
    clickable.style.display = "none";
  }else{
      const finalizeButton = document.querySelector(".finalize_button");
      finalizeButton.addAttribute("disabled");
      const finalize_message = document.querySelector(".finalize_message");
      finalize_message.style.display = "block";
      const clickable = document.querySelector("#clickable");
      clickable.style.display = "block";
  }
  
}

$(document).ready(function () {
  // Show the first line item wrapper and hide others initially

  $(".person_quantity button").click(function () {
    var that = this;
    setTimeout(function () {
      var person_quantity = $(that).parent().find("input").val();

      // Hide all line item wrappers
      $(".custom-line-items-wrapper > div").hide();
      $(".custom-line-items-wrapper > div").removeClass("active_person");

      // Show additional line item wrappers according to person quantity
      for (var i = 1; i <= person_quantity; i++) {
        $(
          ".custom-line-items-wrapper > .custom-line-item-container:nth-child(" +
            i +
            ")"
        ).show();

        $(
          ".custom-line-items-wrapper > .custom-line-item-container:nth-child(" +
            i +
            ")"
        ).addClass("active_person");
      }
    }, 200);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var accordions = document.querySelectorAll(".variant_accordion");

  accordions.forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      this.classList.toggle("open");

      var chevron = this.querySelector(".chevron");
      chevron.classList.toggle("bottom");

      // var parentContainer = this.closest(".parent-container");
      debugger;
      var variantPanels = document.querySelectorAll(".variant_pannel");

      variantPanels.forEach(function (panel) {
        if (panel.classList.contains("show")) {
          panel.classList.remove("show");
          panel.classList.add("hide");
        } else if (panel.classList.contains("hide")) {
          panel.classList.remove("hide");
          panel.classList.add("show");
        }
      });
    });
  });
});
$(document).ready(function () {
  $(".load_more_button").on("click", function () {
    var $featuredItems = $(".featured_col-slider > li");

    if ($featuredItems.hasClass("show")) {
      $featuredItems.removeClass("show").addClass("hide");
      $(this).text("View More");
    } else {
      $featuredItems.removeClass("hide").addClass("show");
      $(this).text("View Less");
    }
  });
});

// JavaScript to toggle accordion on mobile screens
document.addEventListener("DOMContentLoaded", function () {
  const accordion = document.querySelector(".cart-note-accordion");
  const panel = document.querySelector(".cart-note-panel");

  // Toggle accordion
  if (accordion) {
  accordion.addEventListener("click", function () {
    this.classList.toggle("active");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
  }
});


$('#image_upload').on('change', function(){
  if (this.files && this.files[0]) {
      console.log('File selected:', this.files[0].name);
$('.finalize_order').attr('disabled',false)
  } else {
      console.log('No file selected');
      $('.finalize_order').attr('disabled',true)
  }
});

